// views/profile/Perfil/RedirectPerfilColaborador.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/context/AuthContext'; // ajusta el path si es necesario

const RedirectPerfilColaborador = () => {
  const { idColaborador, authReady } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authReady) return; // 👈 Espera a que el contexto esté listo

    if (idColaborador) {
      navigate(`/app/PerfilColaborador/${idColaborador}`, { replace: true });
    } else {
      // Fallback si no existe id (elige la ruta que sí tengas)
      navigate('/app/PerfilColaborador', { replace: true });
    }
  }, [authReady, idColaborador, navigate]);

  return null;
};

export default RedirectPerfilColaborador;
